function Products() {
  // Product data array - easier to manage and update
  const products = [
    {
      id: 1,
      name: "Fertile Eggs",
      description: "Farm-fresh fertile eggs from selected breeding stock. Ideal for incubation.",
      image: "/images/turkey_eggs.png",
      alt: "Fertile turkey eggs"
    },
    {
      id: 2,
      name: "Day-Old Poults",
      description: "Healthy day-old turkeys brooded under controlled conditions. Strong stock.",
      image: "/images/day_old_poults.png",
      alt: "Day-old turkey poults",
      contain: true
    },
    {
      id: 3,
      name: "Live Birds",
      description: "Mature turkeys for farmers, restaurants & homes. Growers & breeding stock available.",
      image: "/images/live_birds.png",
      alt: "Live mature turkeys",
      contain: true
    },
    {
      id: 4,
      name: "Turkey Meat",
      description: "Farm-raised, hygienically processed. Whole birds & custom cuts available.",
      image: "/images/turkey_meat.png",
      alt: "Processed turkey meat"
    },
    {
      id: 5,
      name: "Poultry Feed",
      description: "High-protein feed formulated for turkeys. Better growth & performance. Coming Soon!",
      // TODO: Replace with your own image
      image: "/images/poultry_feed.jpeg",
      alt: "Organic poultry feed"
    }
  ];

  return (
    <section className="py-24 px-6 bg-cream dark:bg-gray-900/50" id="products">
      <div className="max-w-[1200px] mx-auto">

        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-black text-earth dark:text-white mb-4">
            Our Premium Products
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto font-medium">
            From farm-fresh eggs to ready-to-cook processed meat, we provide high-grade poultry products for every need. Contact us for current pricing.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white dark:bg-background-dark p-2 rounded-xl shadow-sm hover:shadow-xl transition-all border border-gray-100 dark:border-gray-800 group"
            >
              {/* Product Image */}
              <div className="aspect-square overflow-hidden rounded-lg mb-4">
                <img
                  className={`w-full h-full ${product.contain ? 'object-contain' : 'object-cover'} group-hover:scale-110 transition-transform duration-500`}
                  loading="lazy"
                  src={product.image}
                  alt={product.alt}
                />
              </div>

              {/* Product Info */}
              <div className="px-2 pb-2">
                <h3 className="font-extrabold text-lg mb-1 text-earth dark:text-white">
                  {product.name}
                </h3>
                <p className="text-sm text-gray-500 leading-snug font-medium">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Products;